import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {isBrowser, isMobile} from 'react-device-detect';
import {getCustomerCoreProducts, openWorkOrder, resetIsWorkOrderSucceeded} from '../SelfCareNavBarBlock/selfCareNavBarSlice';
import ServiceBox from './ServiceBox';
import images from './images/images';
import './OurProductsBar.scss';

function OurProductsBar({
  context,
  iContent,
  UserServices,
  isOrganizationId,
  openWorkOrder,
  isWorkOrderSucceeded,
  resetIsWorkOrderSucceeded,
  organizationData,
  organizationWorkOrderCode,
  organizationWorkOrderTeam,
  loginData
}) {
  return (
    <Container className='our-products-root-container'>
      {UserServices && UserServices.length > 0 && UserServices.indexOf('Error') === -1 ? (
        <>
          <h4 className='header'>{window.Config.brand_Name_HE} שלך</h4>
          <Row className='our-products-row'>
            <Col className='box'>
              {ServiceBox(
                'Cellular',
                'סלולר',
                images.mobileSmall,
                iContent.cellularLink.value,
                iContent.cellularBusinessLink.value,
                UserServices,
                images.arrowSmall,
                isOrganizationId,
                context,
                iContent,
                openWorkOrder,
                isWorkOrderSucceeded,
                resetIsWorkOrderSucceeded,
                organizationWorkOrderCode,
                organizationWorkOrderTeam,
                loginData
              )}
            </Col>
            <Col className='box'>
              {ServiceBox(
                'TV',
                `${window.Config.brand_Name_HE} TV`,
                images.tvSmall,
                iContent.tvLink.value,
                iContent.tvBusinessLink.value,
                UserServices,
                images.arrowSmall,
                isOrganizationId,
                context,
                iContent,
                openWorkOrder,
                isWorkOrderSucceeded,
                resetIsWorkOrderSucceeded,
                organizationWorkOrderCode,
                organizationWorkOrderTeam,
                loginData
              )}
            </Col>
            <Col className='box'>
              {ServiceBox(
                'Internet',
                'אינטרנט ביתי',
                images.internetSmall,
                iContent.internetLink.value,
                iContent.internetBusinessLink.value,
                UserServices,
                images.arrowSmall,
                isOrganizationId,
                context,
                iContent,
                openWorkOrder,
                isWorkOrderSucceeded,
                resetIsWorkOrderSucceeded,
                organizationWorkOrderCode,
                organizationWorkOrderTeam,
                loginData
              )}
              {/* <div className='border'></div> */}
            </Col>
            <Col className='box'>
              {ServiceBox(
                'Energy',
                'חסכון בחשמל',
                images.electricitySmall,
                iContent.electricityLink.value,
                iContent.electricityBusinessLink.value,
                UserServices,
                images.arrowSmall,
                isOrganizationId,
                context,
                iContent,
                openWorkOrder,
                isWorkOrderSucceeded,
                resetIsWorkOrderSucceeded,
                organizationWorkOrderCode,
                organizationWorkOrderTeam,
                loginData
              )}
            </Col>
          </Row>
        </>
      ) : null}
    </Container>
  );
}

const mapStateToProps = (state) => ({
  UserServices: state.selfCareNavBarBlock.userServices,
  isOrganizationId: state.welcomeBlock?.organizationState?.organizationCodeList?.value?.length > 0,
  isWorkOrderSucceeded: state.selfCareNavBarBlock.isWorkOrderSucceeded,
  organizationWorkOrderCode: state.welcomeBlock?.organizationState?.jobCodeJoinProducts?.value,
  organizationWorkOrderTeam: state.welcomeBlock?.organizationState?.teamCodeJoinProducts?.value,
  loginData: state.authentication?.loginData
});

const mapDispatchToProps = {
  getCustomerCoreProducts,
  openWorkOrder,
  resetIsWorkOrderSucceeded,
};

export default connect(mapStateToProps, mapDispatchToProps)(OurProductsBar);
